import { Flex } from "antd";
import { Navbar } from "../../components/navbar";
import { FooterSection2 } from "../../layouts/footer_section_2";
import { Head } from "@inertiajs/react";

const TEXT_SECONDARY = "#556678";
const WA_GREEN = "#25D366";
const WA_LINK =
  "https://wa.me/6281222189918?text=Halo%20tim%20Kidversa%2C%20saya%20tertarik%20dan%20ingin%20menanyakan%20informasi%20lebih%20lanjut%20mengenai%20aplikasi%20ini.";

function Contact() {
  return (
    <>
      <Head>
        <title>Kidversa - Contact</title>
      </Head>
      <Flex vertical align="center" style={{ minHeight: "100vh" }}>
        <Navbar />

        <main
          style={{
            width: "100%",
            maxWidth: 720,
            margin: "0 auto",
            padding: "120px 24px 80px",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            flex: 1,
          }}
        >
          <Flex
            vertical
            align="center"
            gap={20}
            style={{
              width: "100%",
              maxWidth: 420,
              padding: "36px 32px",
              borderRadius: 20,
              background: "#ffffff",
              border: "1px solid #e8ecf2",
              boxShadow: "0 4px 24px rgba(0, 0, 0, 0.05)",
            }}
          >
            <Flex vertical align="center" gap={6}>
              <span
                style={{
                  fontSize: 13,
                  fontWeight: 700,
                  color: TEXT_SECONDARY,
                  textTransform: "uppercase",
                  letterSpacing: "0.1em",
                  fontFamily: "'Quicksand', sans-serif",
                }}
              >
                Hubungi Kami
              </span>
              <p
                style={{
                  margin: 0,
                  fontSize: 13,
                  color: "#94a3b8",
                  textAlign: "center",
                  fontFamily: "'Quicksand', sans-serif",
                }}
              >
                Untuk informasi lebih lanjut, silakan hubungi kami melalui
                WhatsApp.
              </p>
            </Flex>

            <a
              href={WA_LINK}
              target="_blank"
              rel="noopener noreferrer"
              style={{
                display: "inline-flex",
                alignItems: "center",
                gap: 10,
                padding: "14px 32px",
                borderRadius: 14,
                background: WA_GREEN,
                color: "#ffffff",
                fontSize: 15,
                fontWeight: 700,
                fontFamily: "'Quicksand', sans-serif",
                textDecoration: "none",
                transition: "all 0.3s ease",
                boxShadow: "0 4px 16px rgba(37, 211, 102, 0.3)",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = "translateY(-2px)";
                e.currentTarget.style.boxShadow =
                  "0 8px 28px rgba(37, 211, 102, 0.4)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = "translateY(0)";
                e.currentTarget.style.boxShadow =
                  "0 4px 16px rgba(37, 211, 102, 0.3)";
              }}
            >
              <svg
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="currentColor"
              >
                <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" />
              </svg>
              Kontak Tim
            </a>

            <span
              style={{
                fontSize: 12,
                color: "#94a3b8",
                fontFamily: "'Quicksand', sans-serif",
              }}
            >
              Tersedia pada jam kerja (08.00 - 17.00 WIB)
            </span>
          </Flex>
        </main>

        <FooterSection2 />
      </Flex>
    </>
  );
}

export default Contact;
